import { Fragment } from 'react';
import styled from 'styled-components';

const TableContainer = styled.div`
  width: 100%;
  max-width: 940px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  gap: 96px;
  padding: 0;
  .comparisonTableContainer {
    width: 100%;
    font-family: inherit;
    margin: auto;
    position: relative;
    overflow-anchor: none;
  }
  .comp-table__tableHead.stickyHeader {
    position: fixed;
    z-index: 999;
    overflow-x: scroll;
    top: 0px;
  }
  .comp-table__tableHead.stickyHeader.atBottom {
    position: absolute;
    z-index: 999;
    bottom: 0px;
    left: 0px !important;
    top: initial;
    width: initial !important;
    overflow-x: clip;
  }
  th {
    vertical-align: top;
  }
  .comparisonTableContainer use:nth-child(2) {
    transform: translate(20px);
  }
  .comparisonTableContainer use:nth-child(3) {
    transform: translate(40px);
  }
  .comparisonTableContainer use:nth-child(4) {
    transform: translate(60px);
  }
  .comparisonTableContainer use:nth-child(5) {
    transform: translate(80px);
  }
  .comparisonTableContainer .rating {
    height: 20px;
    width: 100px;
  }
  .comparisonTableContainer #stars-empty-star {
    fill: #f1e8ca;
  }
  .comparisonTableContainer #stars-full-star,
  .comparisonTableContainer #stars-half-star {
    fill: #fdcc0d;
  }
  @media (max-width: 769px) {
    .comp-table__columnGroup .comp-table__tableData,
    .comp-table__columnGroupSection .comp-table__tableData,
    .comp-table__columnHeader:nth-child(2),
    .comp-table__tableBodyRow .comp-table__tableData:nth-child(2) {
      border-left: 1px solid #bdbdbd !important;
    }
    .comp-table__emptyCell,
    .comp-table__rowheader {
      display: none;
    }
    .comp-table__productImage {
      height: auto;
      max-width: 100%;
    }
    .comp-table__columnGroupSection .comp-table__tableData {
      text-align: left;
    }
    .comparisonTableContainer
      .comp-table
      .comp-table__tableData:not([scope='colgroup']) {
      min-width: 80px;
      max-width: 80px;
    }
    .comparisonTableContainer.moreThan4
      .comp-table
      .comp-table__tableData:not([scope='colgroup']) {
      min-width: 90px;
      max-width: 90px;
    }
    .comparisonTableContainer.moreThan4
      .comp-table__tableData[scope='colgroup'] {
      text-align: left;
    }
    .comp-table__productImageContainer {
      width: 80px;
      height: 80px;
    }
    .comparisonTableContainer use:nth-child(2) {
      transform: translate(15px);
    }
    .comparisonTableContainer use:nth-child(3) {
      transform: translate(30px);
    }
    .comparisonTableContainer use:nth-child(4) {
      transform: translate(45px);
    }
    .comparisonTableContainer use:nth-child(5) {
      transform: translate(60px);
    }
    .comparisonTableContainer .rating {
      height: 13px;
    }
  }
  .comparisonTableContainer.moreThan4
    .comp-table__tableData[scope='colgroup']
    span {
    padding-left: 10px;
  }
  .comparisonTableContainer.moreThan4 .comp-table__tableData[scope='colgroup'] {
    padding-left: 0;
  }
  .comp-table {
    width: 100%;
    margin: auto;
    border-bottom: 1px solid #bdbdbd !important;
    table-layout: auto;
    border-collapse: separate;
    border-spacing: 0;
  }
  .comparisonTableContainer {
    overflow: auto;
  }
  .comparisonTableContainer .comp-table__tableData:not([scope='colgroup']) {
    min-width: 150px;
    max-width: 150px;
  }
  .comparisonTableContainer .comp-table__rowheader {
    width: 200px !important;
    min-width: 200px !important;
    max-width: 200px !important;
    border-left: 1px solid #bdbdbd !important;
  }
  .comparisonTableContainer .checkmark {
    fill: #4ac263;
  }
  .comparisonTableContainer .xmark {
    fill: #808080;
  }
  .comp-table__tableData {
    border-right: 1px solid #bdbdbd !important;
    border-top: 1px solid #bdbdbd !important;
  }
  .comp-table caption {
    position: absolute;
    opacity: 0;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
  .comp-table__rowheader {
    /*width:20%;*/
    text-align: left;
    padding: 10px;
    left: 0;
    position: sticky;
    position: -webkit-sticky;
  }
  .comp-table__tableData {
    padding: 12px 5px;
    background: #ffffff;
    border-color: #bdbdbd;
    line-height: 1.4;
  }
  [scope='colgroup'] span {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
  }
  .comp-table__columnGroup,
  .comp-table__tableDataCell {
    text-align: center;
    background-clip: padding-box !important;
  }
  .comp-table__columnHeader {
    text-align: left;
  }
  .comp-table__columnHeader p {
    font-weight: normal;
    font-size: 14px;
    margin: 0;
  }
  .comp-table__columnHeader {
    background: #f8f8f8;
    padding: 1rem;
    padding-bottom:;
    position: relative;
    min-width: 50% !important;
  }
  .comp-table__emptyCell {
    border-top: 1px solid #bdbdbd !important;
    border-left: 1px solid #bdbdbd !important;
    background: #f8f8f8;
    position: sticky;
    left: 0;
    z-index: 99;
    padding-left: 20px;
  }
  .comp-table__tableDataCell {
    padding: 12px 5px;
  }
  .comp-table__tableDataCell svg {
    margin: auto;
    display: block;
  }
  .comp-table__tableDataCell > * {
    min-height: 28px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .comp-table__columnHeader:not(.comp-table__recommended)
    .comp-table__recommendedText {
    display: none;
  }
  .comp-table__recommendedText {
    color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 4px 0;
  }
  @media (min-width: 769px) {
    padding: 0 32px;
    .comp-table__tableBodyRow:nth-child(2n),
    .comp-table__tableBodyRow:nth-child(2n) .comp-table__tableData {
      background: #ffffff;
    }
    .comp-table__tableBodyRow:nth-child(4n),
    .comp-table__tableBodyRow:nth-child(4n) .comp-table__tableData {
      background: #f8f8f8;
    }
    .comp-table__columnGroup {
      display: none;
    }
    .comp-table__productImage {
      max-width: 120px !important;
      height: auto;
    }
    .comp-table__rowheader {
      padding-left: 20px !important;
    }
    .comp-table__columnGroupSection .comp-table__tableData {
      text-align: left;
    }
    .comp-table__productImageContainer {
      width: 140px;
      height: 140px;
    }
  }
  .comp-table__columnGroup .comp-table__tableData {
    background: #f0f0f0;
    border-top: 4px solid #bdbdbd !important;
  }
  .comp-table__type {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: auto;
    position: relative;
  }
  .comp-table__productLink:hover {
    filter: brightness(0.9);
  }
  .comp-table__productLink {
    background: #ffffff;
    padding: 12px 2px;
    border-radius: 5px;
    width: 95%;
    line-height: 1.2;
    pointer-events: all !important;
  }
  .comp-table__recommended .comp-table__productLink {
    border: 2px solid transparent;
    background: #f27e3d;
    color: #ffffff;
  }
  .comp-table__price {
    margin-top: 10px;
    margin-bottom: 10px;
    word-break: break-word;
    line-height: 1.2;
  }
  .comp-table__title {
    font-size: 18px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 23px !important;
  }
  .comp-table__recurrence {
    margin-top: -10px;
    margin-bottom: 20px;
    line-height: 1rem;
  }
  .comp-table__columnGroupSection .comp-table__tableData {
    text-transform: uppercase;
    background: #9fd0d1;
    padding: 15px 5px;
    border-left: 1px solid #bdbdbd !important;
  }
  .comp-table__recommended {
    background: #eafbed !important;
  }
  .comp-table__productImageContainer {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 10px;
  }
  .comp-table__tableHead::-webkit-scrollbar {
    height: 0px;
  }
`;

interface Props {
  businessTitle: string;
  financialTitle: string;
  businessText: string;
  financialText: string;
  rows: {
    title: string;
    business: string;
    financial: string;
  }[];
}

const Table = ({
  businessTitle,
  financialTitle,
  businessText,
  financialText,
  rows,
}: Props) => {
  return (
    <TableContainer className="comparison_container">
      <div className="comparisonTableContainer">
        <table className="comp-table">
          <thead className="comp-table__tableHead">
            <tr className="comp-table__columnHeaders comp-table__tableRow">
              <th
                title="Empty placeholder cell"
                className="comp-table__emptyCell comp-table__tableData comp-table__columnHeader"
              ></th>
              <th
                scope="col"
                className=" comp-table__tableData comp-table__columnHeader"
              >
                <div className="comp-table__type">
                  <h3 className="comp-table__title">{businessTitle}</h3>
                  <p>{businessText}</p>
                </div>
              </th>
              <th
                scope="col"
                className=" comp-table__tableData comp-table__columnHeader"
              >
                <div className="comp-table__type">
                  <h3 className="comp-table__title">{financialTitle}</h3>
                  <p>{financialText}</p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="comp-table__tableBody">
            {rows.map((row) => (
              <Fragment key={row.title}>
                <tr className="comp-table__columnGroup comp-table__tableRow">
                  <th
                    scope="colgroup"
                    className="comp-table__tableData"
                    colSpan={2}
                  >
                    <span>{row.title}</span>
                  </th>
                </tr>
                <tr className="comp-table__tableRow comp-table__tableBodyRow">
                  <th
                    className="comp-table__tableData comp-table__rowheader"
                    scope="row"
                  >
                    {row.title}
                  </th>
                  <td className="comp-table__tableData comp-table__tableDataCell ">
                    {row.business}
                  </td>
                  <td className="comp-table__tableData comp-table__tableDataCell ">
                    {row.financial}
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </TableContainer>
  );
};

export default Table;
